"use client";
import LazyBackgrounds from "@/components/LazyBackgrounds";
import { ReactNode } from "react";
import { ThemeProvider } from "../Context/ThemeContext";

interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <>
      <ThemeProvider>
        <LazyBackgrounds />
        {children}
      </ThemeProvider>
    </>
  );
}
